import React, { useImperativeHandle, forwardRef, useState, useRef, useEffect } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { CascadeSelect } from 'primereact/cascadeselect';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from "primereact/dropdown";
import { FileUpload } from 'primereact/fileupload';
import { InputText } from "primereact/inputtext";
import { Toast } from 'primereact/toast';
import axios from 'axios';
import { triggerAlert } from "utils/CommonFunctions";
import { set } from "lodash";

const MoreACcompanies = forwardRef(({ selectedCustomers, setSelectedCustomers, getCompanydata, type, param, first, rows,onStatusChanged, isStatusActive }, ref) => {
    const [changeStatusAction, setChangeStatusAction] = useState(false);
    const [isAttachDocumentVisible, setIsAttachDocumentVisible] = useState(false);
    const [selectedLinkJob, setSelectedLinkJob] = useState(null);
    const [selectedDocumentType, setSelectedDocumentType] = useState(null);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [docSubject, setDocSubject] = useState("");
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [warningDialogueVisible, setWarningDialogueVisible] = useState(false);
    const [statusOptions, setStatusOptions] = useState([]);
    const toast = useRef(null);
    const fileUploadRef = useRef(null);

    // Fetch status options on component mount
    useEffect(() => {
        const fetchStatusOptions = async () => {
            try {
                const response = await axios.get(`/api/v1/company-status/`);
                const formattedOptions = response?.data?.map(status => ({
                    id: status?.id,
                    label: status?.company_status,
                }));
                setStatusOptions(formattedOptions);
            } catch (error) {
                console.error('Error fetching status options:', error);
                toast.current.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to fetch status options',
                    life: 3000
                });
            }
        };

        fetchStatusOptions();
    }, []);


    const [documentTypes, setDocumentTypes] = useState([]);
    const [isActionInProgress, setIsActionInProgress] = useState(false);

    useEffect(() => {
        const fetchDocumentTypes = async () => {
            try {
                const response = await axios.get(`/api/v1/get-all-document-type/`);
                const formatted = response?.data?.results?.map(doc => ({
                    name: doc?.value,
                    code: doc?.id,
                }));
                setDocumentTypes(formatted);
            } catch (error) {
                console.error("Failed to fetch document types:", error);
                toast.current.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Unable to load document types',
                    life: 3000
                });
            }
        };

        fetchDocumentTypes();
    }, []);

   const moreoptions = [
        ...(isStatusActive ? [{
            name: "Attachments",
            onClick: () => {
                if (selectedCustomers.length > 0) {
                    setIsAttachDocumentVisible(true);
                } else {
                    setWarningDialogueVisible(true);
                }
            }
        }] : []),
        {
            name: "Change Status",
            onClick: () => {
                if (selectedCustomers.length > 0) {
                    setChangeStatusAction(true);
                } else {
                    setWarningDialogueVisible(true);
                }
            }
        },
    ];

    useImperativeHandle(ref, () => ({
        openAttachments: () => {
            if (selectedCustomers.length > 0) {
                setIsAttachDocumentVisible(true);
            } else {
                setWarningDialogueVisible(true);
            }
        },
        openChangeStatus: () => {
            if (selectedCustomers.length > 0) {
                setChangeStatusAction(true);
            } else {
                setWarningDialogueVisible(true);
            }
        }
    }));

    // const documentTypes = [
    //     { name: "Company Profiles", code: "INV" },
    //     { name: "Company Contact Lists", code: "CTR" },
    //     { name: "Company Invoices", code: "PRP" },
    //     { name: "Company Feedback Forms", code: "RPT" },
    //     { name: "Company Policies", code: "AGR" },
    //     { name: "Company Job Posting Templates", code: "JPT" },
    //     { name: "Company Evaluation Forms", code: "EF" },
    //     { name: "Company Tax Documents", code: "TAX" },
    //     { name: "Company Termination Notices", code: "CTN" },
    //     { name: "Job Description", code: "JD" },
    // ];

    const forbiddenExtensions = ['js', 'ts', 'jsx', 'tsx', 'py', 'java', 'c', 'cpp', 'cs', 'rb', 'php', 'sh', 'html', 'css', 'json', 'csv'];

    const onUpload = (event) => {
        const files = Array.from(event.files);

        const hasLargeFile = files.some(file => file.size > 10000000);
        const hasForbiddenFile = files.some(file => {
            const extension = file.name.split('.').pop().toLowerCase();
            return forbiddenExtensions.includes(extension);
        });

        if (hasLargeFile) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'One or more files exceed the 10MB limit',
                life: 3000
            });
            fileUploadRef.current?.clear(); // Clear UI
            return;
        }

        if (hasForbiddenFile) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'This Types of files are not allowed',
                life: 3000
            });
            fileUploadRef.current?.clear(); // Clear UI
            return;
        }

        setUploadedFiles(files);
    };

    useEffect(() => {
        if (selectedCustomers?.length > 0 && selectedCustomers[0]?.status) {
            const customerStatus = selectedCustomers[0]?.status;
            const defaultStatusOption = statusOptions?.find(option => option?.label === customerStatus);
            if (defaultStatusOption) {
                setSelectedStatus(defaultStatusOption);
            }
        }
    }, [selectedCustomers, statusOptions]);

    const onRemove = (event) => {
        const fileToRemove = event?.file;
        setUploadedFiles((prevFiles) => prevFiles?.filter(file => file?.name !== fileToRemove?.name));
    };

    const onClear = () => {
        setUploadedFiles([]);
    };

    const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const base64String = reader.result.split(',')[1];
                if (!base64String) {
                    reject(new Error('Failed to encode file to Base64'));
                }
                resolve({
                    file_name: file.name,
                    file_data: base64String,
                });
            };
            reader.onerror = (error) => reject(error);
        });
    };

    const handleCreateDocument = async () => {
        if (isActionInProgress) return; // Prevent multiple clicks

        setIsActionInProgress(true);

        if (!selectedDocumentType || !docSubject) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Please select document type and enter subject',
                life: 3000
            });
            setIsActionInProgress(false);
            return;
        }

        if (uploadedFiles.length === 0) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Please upload at least one document',
                life: 3000
            });
            setIsActionInProgress(false);
            return;
        }

        if (selectedCustomers.length === 0) {
            triggerAlert("warning", "Warning", "Please select a company!");
            setSelectedDocumentType(null);
            setDocSubject("");
            setUploadedFiles([]);
            setIsAttachDocumentVisible(false);
            setIsActionInProgress(false);
            return;
        }

        try {
            const attachments = await Promise.all(
                uploadedFiles?.map(async (file) => {
                    try {
                        return await fileToBase64(file);
                    } catch (error) {
                        throw new Error(`Failed to process file ${file?.name}: ${error?.message}`);
                    }
                })
            );

            const payload = {
                company_id: selectedCustomers[0]?.company_id,
                document_type: selectedDocumentType.code,
                document_subject: docSubject,
                attachments,
            };

            console.log('Sending payload:', JSON.stringify(payload, null, 2));

            const response = await axios.post(
                `/api/v1/documents/`,
                payload,
            );

            toast.current.show({
                severity: 'success',
                summary: 'Success',
                detail: 'Document created successfully',
                life: 3000
            });

            setSelectedDocumentType(null);
            setDocSubject("");
            setUploadedFiles([]);
            setIsAttachDocumentVisible(false);

            if (fileUploadRef.current) {
                fileUploadRef.current.clear();
            }
        } catch (error) {
            console.error('Error creating document:', {
                message: error.message,
                response: error.response?.data,
                status: error.response?.status,
            });

            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: error.response?.data?.message || 'Failed to create document',
                life: 3000
            });
        } finally {
            setIsActionInProgress(false);
        }
    };

    // const handleChangeStatus = async () => {
    //     if (isActionInProgress) return; // Prevent multiple clicks

    //     setIsActionInProgress(true);

    //     if (!selectedStatus) {
    //         toast.current.show({
    //             severity: 'error',
    //             summary: 'Error',
    //             detail: 'Please select a status',
    //             life: 3000
    //         });
    //         setIsActionInProgress(false);
    //         return;
    //     }

    //     if (selectedCustomers.length === 0) {
    //         triggerAlert("warning", "Warning", "Please select a contact!");
    //         setChangeStatusAction(false);
    //         setSelectedStatus(null);
    //         setIsActionInProgress(false);
    //         return;
    //     }

    //     try {
    //         const companyIds = selectedCustomers?.map(customer => customer?.company_id).join(',');
    //         const response = await axios.patch(
    //             `/api/v1/company/${companyIds}/change-status/`,
    //             {
    //                 status: selectedStatus.id
    //             }
    //         );

    //         toast.current.show({
    //             severity: 'success',
    //             summary: 'Success',
    //             detail: 'Contact status updated successfully',
    //             life: 3000
    //         });

    //         setChangeStatusAction(false);
    //         setSelectedStatus(null);
    //         setSelectedCustomers([]); // Clear selected customers

    //         // Refresh company data
    //         const page = Math.floor(first / rows) + 1;
    //         await getCompanydata(page, type, param);
    //     } catch (error) {
    //         console.error('Error changing status:', error);

    //         toast.current.show({
    //             severity: 'error',
    //             summary: 'Error',
    //             detail: error.response?.data?.message || 'Failed to change status',
    //             life: 3000
    //         });
    //     } finally {
    //         setIsActionInProgress(false);
    //     }
    // };
// ...existing code...
const handleChangeStatus = async () => {
    if (isActionInProgress) return; // Prevent multiple clicks

    setIsActionInProgress(true);

    if (!selectedStatus) {
        toast.current.show({
            severity: 'error',
            summary: 'Error',
            detail: 'Please select a status',
            life: 3000
        });
        setIsActionInProgress(false);
        return;
    }

    if (selectedCustomers.length === 0) {
        triggerAlert("warning", "Warning", "Please select a contact!");
        setChangeStatusAction(false);
        setSelectedStatus(null);
        setIsActionInProgress(false);
        return;
    }

    try {
        const companyIds = selectedCustomers?.map(customer => customer?.company_id).join(',');
        await axios.patch(
            `/api/v1/company/${companyIds}/change-status/`,
            {
                status: selectedStatus.id
            }
        );

        toast.current.show({
            severity: 'success',
            summary: 'Success',
            detail: 'Contact status updated successfully',
            life: 3000
        });

        setChangeStatusAction(false);
        setSelectedStatus(null);
        setSelectedCustomers([]); // Clear selected customers

        // Call the parent's status change handler to update dropdown and fetch new data
        if (typeof ref?.current?.onStatusChanged === "function") {
            ref.current.onStatusChanged(selectedStatus.id);
        } else if (typeof window.onStatusChanged === "function") {
            window.onStatusChanged(selectedStatus.id);
        }
        // If passed as prop:
        if (typeof onStatusChanged === "function") {
            onStatusChanged(selectedStatus.id);
        }

    } catch (error) {
        console.error('Error changing status:', error);

        toast.current.show({
            severity: 'error',
            summary: 'Error',
            detail: error.response?.data?.message || 'Failed to change status',
            life: 3000
        });
    } finally {
        setIsActionInProgress(false);
    }
};
// ...existing code...

    return (
        <React.Fragment>
            <Toast ref={toast} />

            <CascadeSelect
                value={selectedLinkJob}
                onChange={(e) => {
                    if (e.value && e.value.onClick) {
                        e.value.onClick();
                    }
                }}
                options={moreoptions}
                optionLabel="name"
                optionGroupLabel="name"
                optionGroupChildren={["jobs"]}
                placeholder="More"
                className="me-1"
            />

            <Dialog
                header="Warning"
                visible={warningDialogueVisible}
                modal
                onHide={() => setWarningDialogueVisible(false)}
                style={{ width: "30vw" }}
                className="modal-content"
            >
                <div className="p-3">
                    <p>Please select at least one Company to proceed.</p>
                    <div className="d-flex justify-content-end mt-4">
                        <Button
                            type="button"
                            label="OK"
                            className="btn btn-primary btn-main"
                            onClick={() => setWarningDialogueVisible(false)}
                        />
                    </div>
                </div>
            </Dialog>

            <Dialog
                header="Change Status"
                visible={changeStatusAction}
                modal
                onHide={() => {
                    setChangeStatusAction(false);
                    // setSelectedStatus(null);
                }}
                style={{ width: '30vw' }}
                className="modal-content"
            >
                <Row className="mt-2 align-items-center">
                    <Col md={2}>
                        <label className="status-label mb-2">
                            Status
                        </label>
                    </Col>
                    <Col md={10}>
                        <Dropdown
                            value={selectedStatus}
                            onChange={(e) => setSelectedStatus(e.value)}
                            options={statusOptions}
                            optionLabel="label"
                            placeholder="Select Status"
                            className="w-full"
                        />
                    </Col>
                </Row>
                <div className="d-flex justify-content-end mt-4">
                    <Button
                        type="button"
                        label="Change Status"
                        className="btn btn-primary btn-main"
                        onClick={handleChangeStatus}
                        disabled={isActionInProgress}
                    />
                </div>
            </Dialog>

            {/* Create Attachments Dialog */}
            <Dialog
                header="Attachments"
                visible={isAttachDocumentVisible}
                onHide={() => {
                    setIsAttachDocumentVisible(false);
                    setDocSubject("");
                    setSelectedDocumentType(null);
                    setUploadedFiles([]);
                    if (fileUploadRef.current) {
                        fileUploadRef.current.clear();
                    }
                }}
                style={{ width: '45vw' }}
                breakpoints={{ '960px': '75vw', '641px': '90vw' }}
            >
                <Row className="align-items-center">
                    <Col xl={6}>
                        <div className="card flex justify-content-center mb-0 border-0">
                            <label className="block mb-2">
                                Document Type <span style={{ color: "red" }}>*</span>
                            </label>
                            <Dropdown
                                value={selectedDocumentType}
                                onChange={(e) => setSelectedDocumentType(e.value)}
                                options={documentTypes}
                                optionLabel="name"
                                placeholder="Select a Document Type"
                                className="w-full bgclr"
                            />
                        </div>
                    </Col>

                    <Col lg={6}>
                        <div className="p-field mt-2">
                            <label htmlFor="docSubject" className="block">Document Subject <span style={{ color: "red" }}>*</span></label>
                            <InputText
                                id="docSubject"
                                value={docSubject}
                                onChange={(e) => setDocSubject(e.target.value)}
                                placeholder="Enter Document Subject"
                                className="p-inputtext-sm w-full"
                            />
                        </div>
                    </Col>

                    <Col lg={12}>
                        <div className="card flex justify-content-center mb-0 border-0 mt-2">
                            <label className="block mb-2">
                                Attach Documents <span style={{ color: "red" }}>*</span>
                            </label>
                            <FileUpload
                                ref={fileUploadRef}
                                name="demo[]"
                                accept=".pdf,.docx,image/jpeg,image/png,image/jpg"
                                maxFileSize={10000000}
                                customUpload
                                auto
                                onSelect={onUpload}
                                onRemove={onRemove}
                                onClear={onClear}
                                multiple
                                emptyTemplate={<p className="m-0">Drag and drop files to here to upload.</p>}
                                itemTemplate={(file, props) => {
                                    // Format the size in KB
                                    const sizeInKB = (file.size / 1024).toFixed(2) + ' KB';

                                    return (
                                        <div className="w-full flex justify-content-between p-2 border-round-sm">
                                            <div>
                                                <div>{file.name}</div>
                                                <small>{sizeInKB}</small>
                                            </div>
                                            <Button
                                                icon="pi pi-times"
                                                className="p-button-rounded p-button-text"
                                                onClick={() => props.onRemove(file)}
                                            />
                                        </div>
                                    );
                                }}
                            />
                            <small className="text-muted">
                                Note: Maximum file size is 2MB. Allowed formats: PDF, DOCX, JPEG, PNG, JPG.
                            </small>
                        </div>
                    </Col>

                    <Col lg={12}>
                        <button
                            className="btn btn-primary btn-main mt-2"
                            onClick={handleCreateDocument}
                            disabled={isActionInProgress || !selectedDocumentType || !docSubject.trim() || uploadedFiles.length === 0}

                        >
                            Submit
                        </button>
                    </Col>
                </Row>
            </Dialog>
        </React.Fragment>
    );
});

export default MoreACcompanies;